import React from 'react';
import {
  Box,
  Container,
  Typography,
} from '@mui/material';
import AnimatedElement from './AnimatedElement';
import { useSection } from '../context/CmsContext';
import { withLineBreaks } from '../lib/text';

const AboutSection = () => {
  const about = useSection('about');

  return (
    <Box
      id="about"
      sx={{
        py: { xs: 8, md: 12 },
        bgcolor: 'primary.white'
      }}
    >
      <Container 
        maxWidth={false} 
        sx={{ 
          maxWidth: '1400px',
          px: { xs: 2, sm: 2.5, md: 4 },
          mx: 'auto',
          mb: 8
        }}
      >
         <AnimatedElement>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '3fr 7fr 1fr' },
            gap: 2,
            alignItems: 'start'
          }}
        >
          {/* Spalte 1: Sektionsüberschrift */}
          
          <Box>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                 fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2.1rem' },
                fontWeight: 500,
                color: '#000',
                lineHeight: 1.2,
                textAlign: 'left'
              }}
            >
              {withLineBreaks(about.heading)}
            </Typography>
            <Box 
              sx={{
                height: '4px', 
                width: '100px', 
                backgroundColor: 'rgb(58, 123, 62)', 
                marginTop: { xs: '20px', sm: '30px', md: '40px' },
                marginBottom: '20px'
              }}
            />
          </Box>

          {/* Spalte 2: Zweispaltiger Fließtext */}
          <Box>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.6,
                color: '#000',
                textAlign: 'left',
                columnCount: { xs: 1, lg: 2 },
                columnGap: '2rem',
                margin: 0,
                '& p': {
                  breakInside: 'avoid',
                  pageBreakInside: 'avoid', // Fallback
                  marginTop: 0, // Entfernt Abstand über dem ersten Absatz
                  marginBottom: 2 // Abstand zwischen Absätzen
                },
                '& p:first-of-type': {
                  marginTop: 0 // Explizit für den ersten Absatz
                },
                columnRule: 'none'
              }}
            >
              {(about.paragraphs || []).map((text, index) => (
                <p key={index}>{text}</p>
              ))}
            </Typography>
          </Box>

          {/* Spalte 3: Gedrehter Text "CORPS" */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              alignItems: 'flex-start',
              height: '100%',
              minHeight: { xs: '100px', md: '400px' }
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                            <div style={{ height: '100px', width: '2px', backgroundColor: '#3a7b3e', marginLeft: '-4px' }}></div>
                            <Typography
                              variant="h3"
                              sx={{
                                fontSize: { xs: '0.8rem', md: '0.9rem' },
                                fontWeight: 500,
                                color: '#000',
                                writingMode: { xs: 'horizontal-tb', md: 'vertical-rl' },
                                textOrientation: { md: 'mixed' },
                                whiteSpace: 'nowrap',
                                letterSpacing: '0.2em',
                                textAlign: 'center',
                              }}
                            >
                              {about.label}
                            </Typography>
                          </div>
            
          </Box>
        
        </Box>
          </AnimatedElement>
      </Container>
    </Box>
  );
};

export default AboutSection;
